export type AnomiaError = {
  code: string;
  message: string;
  cause?: unknown;
};

export type Result<T> = { ok: true; value: T } | { ok: false; error: AnomiaError };

export const ok = <T>(value: T): Result<T> => ({ ok: true, value });
export const err = <T = never>(error: AnomiaError): Result<T> => ({ ok: false, error });
